import PlaceAutocomplete from "../components/PlaceAutocomplete.tsx";
import PracticesMapContainer from "../components/PracticesMapContainer.tsx";
import {actions, useApp} from "../providers/AppProvider.tsx";
import {useMap} from "@vis.gl/react-google-maps";
import MobilePracticeInfoWindow from "../components/MobilePracticeInfoWindow.tsx";
import MobilePracticesList from "../components/MobilePracticesList.tsx";


const MobileApp = () => {

    const {dispatch} = useApp()
    const map = useMap()

    return (
        <div className={"bg-primary"}>
            <PlaceAutocomplete onPlaceSelect={(place) => {
                if (place) {
                    map?.setValues({
                        userEnteredSearch: 1
                    })
                    dispatch(actions.setUserLocation(place))
                }
            }}/>

            <div className={"relative"}>
                <PracticesMapContainer/>
                <MobilePracticeInfoWindow/>
            </div>
            <div className={"pt-4 "}>
                <MobilePracticesList/>
            </div>


        </div>
    )
}

export default MobileApp;